export default {
  header: 'Récapitulatif de commande',
  buttons: {
    checkout: 'Paiement sécurisé',
    continue: 'Continuer',
    add_products: '+ Ajouter des produits',
    add_items: '+ Ajouter des articles',
    menu: 'Menu',
  },
  empty_order_basket: {
    description: 'Votre panier est vide <br/> Ajoutez des articles pour commencer',
  },
  promo_code_banner: {
    single_use: '{{discount}} de remise - {{code}}',
    multi_use: '{{discount}} de remise sur {{count}} commandes - {{code}}',
    redeem: 'UTILISER',
    redeemed: 'UTILISÉ',
  },
  upsell: {
    title: 'Les autres commandent aussi',
  },
  rewards: {
    title: 'Payer avec des points',
    description: '<highlight>Connectez-vous</highlight> pour payer avec des points',
  },
  already_member: 'Déjà membre ?',
  sign_in: 'Se connecter',
  summary: {
    subtotal: 'Sous-total',
    delivery: 'Livraison',
    pickup: 'À emporter',
    total: 'Total',
    free: 'Gratuit',
  },
  footer: {
    member_earning: '+{{points}} pts après paiement · Solde {{balance}} pts',
    guest_earning: 'Inscrivez-vous pour gagner des points sur cette commande',
  },
};
